import customerInstance from './instance'

const storeCustomer = (options) => {
  return customerInstance.post('/customers', options)
}

export default storeCustomer
